import i18n from 'i18next';
import client from '../apiClient';



function CourseCompletion(userId) {
  return client.get(`/course/getcourseCompletion?userId=${userId}`);
}



function getCourseList(data) {
  return client.get(`/user/enroll/course?data=${data}`, {
    headers: {
      'Accept-Language': i18n.language
    }
  });
}

function getCourseList1(id,data) {
  return client.get(`/user/enroll/course?id=${id}&&data=${data}`, {
    headers: {
      'Accept-Language': i18n.language
    }
  });
}




function getFreeCourseList(en,userId) {
  return client.get(`/user/enroll/course/allfreecourses?userId=${userId}`, {
    headers: {
      'Accept-Language': i18n.language
    }
  });
}




function getRecomdedCourseList(id) {
  return client.get(`/user/enroll/course/recomendedcourses?userId=${id}`, {
    headers: {
      'Accept-Language': i18n.language
    }
  });
}

function getCertificateList() {
  return client.get('/user/enroll/course/certificationcourses', {
    headers: {
      'Accept-Language': i18n.language
    }
  });
}


const getSubscriptionList = (search) => client.get(`/individual/user/subscription?search=${search}`,{headers: {
  'Accept-Language': i18n.language
}});
const getAssessmentSubscriptionList = (search) => client.get(`/individual/user/subscription/assessment?search=${search}`,{headers: {
  'Accept-Language': i18n.language
}});

const getCourseModulesAndSubmodules = (courseId, planId,language) =>
  client.get(`/user/module/submodule/topics?courseId=${courseId}&&planId=${planId}&&language=${language}`,{headers: {
    'Accept-Language': i18n.language,
  }});

const getUserLastCompletedDetails = (courseId) => client.get(`/user/lastCompletedScreen?courseId=${courseId}`);

const getWebsiteIndividualCourses = (frequency) => client.get(`/website/course/individual?frequency=${frequency}`);

const getWebsiteBundleCourses = (frequency,language) => client.get(`/website/course/bundle?frequency=${frequency}&&language=${language}`);
const getCourseCompletionStatus = (courseId,userId) => client.get(`/client/getcoursecompletionDetails?courseId=${courseId}&&userId=${userId}`);
const updateCourseCompletionStatus = (courseId,userId) => client.put(`/client/updateCoursecompletionstatus?courseId=${courseId}&&userId=${userId}`);

const getAssessmentList = (id) => client.get(`/individual/user/getallassessment?id=${id}`);
const getCognitiveAssessment = (id) => client.get(`/individual/user/getallGACognitiveSkill?id=${id}`);
const getIndividualAssessment = (id,userId) => client.get(`/individual/user/getallGACognitiveSkillDetailsId?id=${id}&userId=${userId}`);
const getNEETAssessment = (id) => client.get(`/individual/user/getNEETAssessment?id=${id}`);
const getRecommendedAssessment = (userId) => client.get(`/individual/user/getRecommendedAssessmentByUserId?id=${userId}`);
const getIndividualResult = (userId,assessmentId) => client.get(`/individual/user/getAssessmentOverView?UserId=${userId}&assessmentId=${assessmentId}`);
const getIndividualResultForSat = (userId,assessmentId,type) => client.get(`/individual/user/getAssessmentOverView?UserId=${userId}&assessmentId=${assessmentId}&type=${type}`);
const getIndividualNEETAssessment = (id,userId) => client.get(`/individual/user/getNEETAssessmentDetailsId?id=${id}&userId=${userId}`);
const getSubscribedAssessment = (id) => client.get(`/individual/user/getAllAssessmentByUserId?UserId=${id}`);
const getSatDashboard = (id) => client.get(`/individual/user/getSATAssessment?id=${id}`);
const getSatClonedAssessment = (id,courseid) => client.get(`/individual/user/clonedgetSATAssessment?id=${id}&courseId=${courseid}`);

function getSATList(userId) {
  return client.get(`/user/enroll/Assessments?id=${userId}`, {
    headers: {
      'Accept-Language': i18n.language
    }
  });
}

function getB2BNeet() {
  return client.get(`/subscription/userneetdetails?clientId=40`, {
    headers: {
      'Accept-Language': i18n.language
    }
  });
}

function getDynamicCoursesByCategory(language,userId) {
  return client.get(`/user/enroll/course/dashboardcourses?language=${language}&&userId=${userId}`, {
    headers: {
      'Accept-Language': language
    }
  });
}

const getCourseById = (courseId) =>
  client.get(`/user/enroll/course?courseId=${courseId}`, {
    headers: {
      'Accept-Language': i18n.language
    }
  });

  


export default {
  CourseCompletion,
  getCourseList1,
  getCourseList,
  getCourseById,
  getFreeCourseList,
  getRecomdedCourseList,
  getCertificateList,
  getSubscriptionList,
  getAssessmentSubscriptionList,
  getCourseModulesAndSubmodules,
  getUserLastCompletedDetails,
  getWebsiteIndividualCourses,
  getWebsiteBundleCourses,
  getCourseCompletionStatus,
  updateCourseCompletionStatus,
  getAssessmentList,
  getCognitiveAssessment,
  getIndividualAssessment,
  getRecommendedAssessment,
  getIndividualResult,
  getSubscribedAssessment,
  getSatDashboard,
  getSatClonedAssessment,
  getIndividualResultForSat,
  getSATList,
  getB2BNeet,
  getNEETAssessment,
  getIndividualNEETAssessment,
  getDynamicCoursesByCategory
};
